import { render, staticRenderFns } from "./TheFooterNavigation.vue?vue&type=template&id=87932fce&scoped=true&"
import script from "./TheFooterNavigation.vue?vue&type=script&lang=js&"
export * from "./TheFooterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterNavigation.vue?vue&type=style&index=0&id=87932fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87932fce",
  null
  
)

export default component.exports